import React from "react";
import { Pressable, Text, View } from "react-native";
import AIExhibitNarrationPressable from "../audio/AIExhibitNarrationPressable";
import { useAIExhibitFixedNarration } from "../audio/useAIExhibitFixedNarration";
import { AI_EXHIBIT_COLORS as C } from "../aiExhibitTheme";
import { getAIExhibitBatch4Copy } from "../content/aiExhibitBatch4Content";

export default function ImpactScreen({
  navigate,
  language="en",
  audioEnabled=false,
}){
  const { playNarration } = useAIExhibitFixedNarration({
    audioEnabled,
    language,
  });
  const t=getAIExhibitBatch4Copy(language).impact;
  return <View style={{padding:28}}>
    <Text style={{color:C.accent,fontSize:13,fontWeight:"900",letterSpacing:1.2}}>{t.eyebrow}</Text>
    <Text style={{color:C.text,fontSize:44,lineHeight:50,fontWeight:"900",marginTop:8}}>{t.title}</Text>
    <Text style={{color:C.muted,fontSize:18,lineHeight:27,marginTop:8,maxWidth:970}}>{t.subtitle}</Text>
    <View style={{flexDirection:"row",flexWrap:"wrap",gap:18,marginTop:28}}>
      <Pressable onPress={()=>navigate("people_society")} style={({pressed})=>({flex:1,minWidth:360,minHeight:260,padding:28,borderRadius:22,borderWidth:1,borderColor:C.accent,backgroundColor:pressed?C.surface:C.accentSoft,justifyContent:"center"})}><Text style={{fontSize:54}}>{t.people.icon}</Text><Text style={{color:C.text,fontSize:30,fontWeight:"900",marginTop:16}}>{t.people.title}</Text><Text style={{color:C.muted,fontSize:17,lineHeight:26,marginTop:10}}>{t.people.subtitle}</Text><Text style={{color:C.accent,fontSize:17,fontWeight:"900",marginTop:18}}>Explore →</Text></Pressable>
      <Pressable onPress={()=>navigate("planet")} style={({pressed})=>({flex:1,minWidth:360,minHeight:260,padding:28,borderRadius:22,borderWidth:1,borderColor:C.success,backgroundColor:pressed?C.surface:C.surfaceRaised,justifyContent:"center"})}><Text style={{fontSize:54}}>{t.planet.icon}</Text><Text style={{color:C.text,fontSize:30,fontWeight:"900",marginTop:16}}>{t.planet.title}</Text><Text style={{color:C.muted,fontSize:17,lineHeight:26,marginTop:10}}>{t.planet.subtitle}</Text><Text style={{color:C.success,fontSize:17,fontWeight:"900",marginTop:18}}>Explore →</Text></Pressable>
    </View>
    <AIExhibitNarrationPressable
      audioEnabled={audioEnabled}
      onPress={() => playNarration("impact_balanced_frame")}
      style={{marginTop:20,padding:19,borderRadius:16,borderLeftWidth:5,borderWidth:1,borderColor:C.border,borderLeftColor:C.warning,backgroundColor:C.surfaceRaised}}
    ><Text style={{color:C.text,fontSize:18,lineHeight:28,fontWeight:"800"}}>{t.tone}</Text></AIExhibitNarrationPressable>
  </View>;
}
